import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import cancelIcon from "@icons/ic-cancel.svg";
import { ActionButtons } from "../../EnquiryList.styled";
import AddEditEnquiry from "../../../AddEditEnquiry";
import "../../EnquiryList.scss";

const EnquiryAction = (props) => {
  const { t, enquiryId, step, onRefreshData, enquiryData, page } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isAddEnquiryPopupVisible, setAddEnquiryPopupVisible] = useState(false);
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT"
  );

  useEffect(() => {
    setConfirmationBoxTitle("ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE");
    setConfirmationBoxContent("ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT");
    if (step === 6) {
      setConfirmationBoxTitle("ENQUIRY_DELETE_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "ENQUIRY_DELETE_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
  }, [step]);

  const handleEnquiryStep = (toStatus) => {
    if (toStatus === 6) {
      setConfirmationBoxTitle("ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("ENQUIRY_DELETE_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "ENQUIRY_DELETE_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      const jsonData = {
        previousStepId: enquiryData.step,
        newStepId: enquiryData.step === 6 || page === "createSite" ? 4 : 6,
      };
      axios
        .post(`/enquiries/${enquiryData.id}/transitionStep`, jsonData)
        .then(() => {
          onRefreshData(true);
          setActionConfirmStatus(false);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const onEdit = () => {
    setAddEnquiryPopupVisible(true);
  };
  const closeEnquiryCreationPopup = () => {
    setAddEnquiryPopupVisible(false);
  };

  const updateRefeshStatus = () => {
    onRefreshData(true);
  };

  return (
    <ActionButtons>
      <>
        {step !== 4 && step !== 6 && (
          <Image
            src={editIcon}
            alt={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
            title={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
            className="enquiry-listing__image-icon"
            onClick={onEdit}
          />
        )}
        {(step === 1 || step === 2) && page !== "createSite" && (
          <Image
            src={cancelIcon}
            onClick={() => handleEnquiryStep(6)}
            alt={t("ENQUIRY_ACTION_TOOLTIP_CANCEL")}
            title={t("ENQUIRY_ACTION_TOOLTIP_CANCEL")}
            className="enquiry-listing__image-icon"
          />
        )}
        {page === "createSite" && (
          <Image
            src={deleteIcon}
            onClick={() => handleEnquiryStep(4)}
            alt={t("ENQUIRY_ACTION_TOOLTIP_DISABLE")}
            title={t("ENQUIRY_ACTION_TOOLTIP_DISABLE")}
            className="enquiry-listing__image-icon"
          />
        )}
      </>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {isAddEnquiryPopupVisible && (
        <AddEditEnquiry
          title={t("ENQUIRY")}
          onClose={closeEnquiryCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          siteId={enquiryData?.site?.id}
          platformCountryId={enquiryData?.site?.platformCountry?.id}
          enquiryData={enquiryData}
          id={enquiryData.id}
          isEditMode
        />
      )}
    </ActionButtons>
  );
};

EnquiryAction.propTypes = {
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(EnquiryAction);
